window.Vue = require('vue').default;

const eventBus = new Vue();

export default eventBus
